<template>
  <div v-if="hasPermission(permissions.investorsEdit)">
    <content-header>{{ projectTenant() !== 'Candle' ? $t('editInvestor') : $t('editAgent') }}</content-header>
    <v-content>
      <b-card>
        <b-card-body>
          <form class="forms-sample" @submit.prevent="onSubmit">
            <text-input id="name" :name="$t('name')" :validate="$v" :required="true" :max-length="true" :is-loading="isLoading" />
            <text-input id="invoiceNumber" :name="$t('invoiceNumber')" :validate="$v" :required="true" :max-length="true" :is-loading="isLoading" />
            <number-input id="meter" :name="$t('meter')" :show-locale-string="true" :validate="$v" :required="true" :is-loading="isLoading" />
            <number-input id="mcPaidPrice" :name="$t('paidPrice')" :show-locale-string="true" :validate="$v" :required="true" :is-loading="isLoading" />
            <number-input id="mcNeedToPay" :name="$t('needToPay')" :show-locale-string="true" :validate="$v" :required="true" :is-loading="isLoading" />
            <date-time-input id="date" :name="$t('date')" :default-value="getCurrentDate()" :validate="$v" :required="true" :is-loading="isLoading" />
            <text-area-input id="note" :name="$t('note')" :validate="$v" :is-loading="isLoading" />
            <file-input
                id="attachment"
                :name="$t('attachment')"
                @fileAdded="base64File => form.attachment = base64File"
            />
            <submit-input icon="fa-save" :name="$t('save')" :disabled="isLoading"/>
            <is-loading v-if="isLoading" />
          </form>
        </b-card-body>
      </b-card>
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import { required, maxLength } from 'vuelidate/lib/validators'
import IsLoading from "@/components/IsLoading";
import {Investor} from "@/models/Investor";
import SubmitInput from "@/components/Inputs/SubmitInput";
import FileInput from "@/components/Inputs/FileInput";
import TextInput from "@/components/Inputs/TextInput";
import NumberInput from "@/components/Inputs/NumberInput";
import DateTimeInput from "@/components/Inputs/DateTimeInput";
import TextAreaInput from "@/components/Inputs/TextAreaInput";
import {permissions} from "@/plugins/constants";

export default {
  name: "InvestorEdit",
  components: {TextAreaInput, DateTimeInput, NumberInput, TextInput, SubmitInput, ContentHeader, 'v-content': Content, IsLoading, FileInput},
  data() {
    return {
      form: this.$helpers.convertArrayToObject(new Investor().fillAbles),
      isLoading: false,
      permissions: permissions
    };
  },
  mounted() {
    this.isLoading = true;
    this.$store.dispatch('investors/GET_ONE', this.$route.params.id).then(async (response) => {
      this.form = await response.data;
      this.isLoading = false;
    }).catch(() => this.isLoading = false)
  },
  validations: {
    form: {
      name: {required, maxLength: maxLength(255)},
      invoiceNumber: {},
      meter: {required},
      mcPaidPrice: {required},
      mcNeedToPay: {required},
      date: {required},
      note: {},
      attachment: {},
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$pending || this.$v.$error) return false;
      this.isLoading = true;
      this.$store.dispatch('investors/UPDATE', {id: this.$route.params.id, form: this.form}).then(() => {
        this.$v.$reset();
        this.$router.push({name: "investors"})
      }).catch(() => this.isLoading = false);
    }
  }
}
</script>
